import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
    selector: 'popup-informativo-ava',
    templateUrl: './popup-informativo.component.html',
    styleUrls: ['./popup-informativo.component.scss'],
})
export class PopupInformativoAvaComponent {
    @Input() isPopupAberto: boolean = true
    @Input() titulo: string

    @Output() onClosePopUp: EventEmitter<boolean> = new EventEmitter<boolean>()

    fecharPopup() {
        this.isPopupAberto = false
        this.onClosePopUp.emit(this.isPopupAberto)
    }
}



// WEBPACK FOOTER //
// ./src/app/common/ava/popup-informativo.component.ts